import http from "@/http/aisea/axios";
const resource = "/secure_dataflow/enterprise/vessels";

export default {
  getOrigins(vesselId, params) {
    return http.get(`${resource}/${vesselId}/origins/unique`, {
      params: params,
    });
  },

  getChannelVersions(vesselId, vesselOriginId) {
    return http.get(
      `${resource}/${vesselId}/origins/${vesselOriginId}/channel_versions`
    );
  },
};
